export const site = {
  brand: "Gorla Properties",
  name: "Francesca Gorla",
  role: "Agente Immobiliare",
  email: "francesca@gorlaproperties.com",
  instagram: "https://www.instagram.com/gorlaproperties/",
  instagramHandle: "@gorlaproperties",
  linkedin: "https://www.linkedin.com/in/francesca-gorla-milano",
  linkedinHandle: "francesca-gorla-milano",
  calendly: "https://calendly.com/francesca-gorlaproperties/chiacchera",
  whatsappNumber: "+39 352 004 2494",
  whatsappUrl:
    "https://wa.me/393520042494?text=" +
    encodeURIComponent(
      "Ciao Francesca, ti scrivo da gorlaproperties.com per avere informazioni sui tuoi servizi di locazione."
    ),
  rea: "REA MI - 2800801",
  vat: "P.IVA 12719350964",
  cities: [
    "Milano",
    "Monza",
    "Como",
    "Bergamo",
    "Brescia",
    "Lago di Iseo",
    "Lago di Garda",
    "Roma",
  ],
};
